import { render, staticRenderFns } from "./ChangedFieldList.vue?vue&type=template&id=52e281e6&"
import script from "./ChangedFieldList.vue?vue&type=script&lang=js&"
export * from "./ChangedFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports